/**
 * The arithmetic of an odometer, apart from the component that draws it.
 *
 * Owns: how many digit columns a number needs and which digit each shows.
 * Must not: touch the DOM or know about animation. `RollingNumber.vue` rolls
 * each column by translating a 0-9 stack by `-d` em; the rest is timing.
 */

/** A digit column rolls in 700 ms on `--ease` (life-layer.md §3 P4, odometer). */
export const ROLL_MS = 700;
/** The first count-up from zero, when the figure scrolls into view (life-layer.md §3 P4). */
export const COUNT_UP_SECONDS = 1.6;
/** A later live change: shorter than the first count so a ticking figure keeps up. */
export const FOLLOW_SECONDS = 0.8;

/** Columns needed to show `n` (a whole number, 0 or more): `0` is one column. */
export function digitCount(n: number): number {
  return String(Math.max(0, Math.trunc(n))).length;
}

/** `n`'s digits, most significant first, left-padded with zeros to `width` columns. */
export function digitsOf(n: number, width: number): number[] {
  const text = String(Math.max(0, Math.trunc(n))).padStart(width, '0');
  return Array.from(text, (ch) => Number(ch));
}
